export const firebaseConfig = {
  apiKey: "AIzaSyBgdERxfYg9uv1qzsC3KuS_1GpBdTzQFOM",
  authDomain: "pro-syntez-18b9e.firebaseapp.com",
  projectId: "pro-syntez-18b9e",
  storageBucket: "pro-syntez-18b9e.firebasestorage.app",
  messagingSenderId: "341337035781",
  appId: "1:341337035781:web:8c17a74e24196e7a1bf86c",
  measurementId: "G-ZHME58NX3W"
};
